import { gettext } from '@eventbrite/i18n';
import { TagObject, Tags } from '@eventbrite/tags';
import React from 'react';
import { Header } from '../../components/Header';
import { useLocationContext } from '../../context';
import './NearbyCities.scss';

export type Places = {
    id: string;
    name: string;
    url: string;
    subhead: any;
}[];

export interface NearbyCitiesProps {
    places: Places;
}

export const NearbyCities: React.FunctionComponent<NearbyCitiesProps> = (
    props,
) => {
    const { shortPlaceName } = useLocationContext();

    const tags: TagObject[] = (props.places || []).map((place) => ({
        displayText: gettext('Things to do in %(geo)s', {
            geo: place.name,
        }),
        linkUrl: place.url,
    }));

    const tagConfig = {
        tags,
        backgroundColor: 'white',
        tagColor: '#F8F7FA',
    };

    const nearbyCitiesTitle = gettext(
        'Things to do around %(shortPlaceName)s',
        {
            shortPlaceName: shortPlaceName,
        },
    );

    const showNearbyCities = tags.length > 0;

    return (
        <>
            {showNearbyCities ? (
                <div data-testid="nearby-cities" className="ttd-nearby-cities">
                    <Header title={nearbyCitiesTitle} />
                    <Tags {...tagConfig} />
                </div>
            ) : (
                <></>
            )}
        </>
    );
};
